<template>
  <div
    v-loading="loading"
    class="d-layout-default"
    :class="{ 'is-menu-collapsed': menuCollapsed }"
  >
    <!-- Mobile menu fade background -->
    <transition name="fade">
      <div
        v-show="menuIsOpened"
        class="d-menu-background is-hidden-desktop"
        @click="closeMenu()"
      />
    </transition>

    <!-- Header -->

    <div class="d-top-bar">
      <div class="d-brand">
        <slot name="brand" />
      </div>
      <div
        class="d-menu-button-open is-hidden-desktop"
        @click="openMenu()"
      >
        <b-icon icon="menu" />
      </div>
      <!-- Desktop: bring the collapsed menu back -->
      <button
        v-if="menuCollapsed"
        type="button"
        class="d-menu-expand is-hidden-touch"
        :title="$t('menu_expand')"
        @click="toggleCollapse()"
      >
        <b-icon icon="chevron-right" />
      </button>
      <div class="d-navbar">
        <slot name="navbar" />
      </div>
      <v-account-dropdown />
    </div>

    <div class="d-body">
      <!-- Menu -->
      <aside
        class="d-menu"
        :class="{'is-active': menuIsOpened}"
      >
        <div
          class="d-menu-button-close is-hidden-desktop"
          @click="closeMenu()"
        >
          <b-icon icon="close" />
        </div>

        <div class="d-brand">
          <slot name="brand" />
        </div>
        <!-- Desktop: fold the menu to the left (more room for the lists) -->
        <button
          type="button"
          class="d-menu-collapse is-hidden-touch"
          :title="$t('menu_collapse')"
          @click="toggleCollapse()"
        >
          <b-icon icon="chevron-left" />
        </button>

        <slot name="menu-header" />

        <div
          v-if="$slots.navbar"
          class="d-navbar-mobile"
        >
          <slot name="navbar" />
        </div>

        <slot name="menu" />
      </aside>

      <!-- Content -->
      <div class="d-content">
        <slot name="header" />
        <slot name="body" />
      </div>
    </div>
  </div>
</template>

<script>

import AccountDropdownVue from "./includes/AccountDropdown.vue";

export default {
  metaInfo() {
    return {
      titleTemplate:  "%s - " + this.$laravel.app.name,
      lang: this.$laravel.app.locale
    };
  },
  components: {
    "v-account-dropdown": AccountDropdownVue
  },
  props: {
    loading: {
      default: false,
      type: Boolean
    }
  },
  data() {
    let collapsed = false;

    try {
      collapsed = localStorage.getItem("d-menu-collapsed") === "1";
    } catch (e) {
      collapsed = false;
    }

    return {
      menuIsOpened: false,
      menuCollapsed: collapsed,
    };
  },
  watch: {
    "$route.path" () {
      this.menuIsOpened = false;
      document.documentElement.classList.remove("is-no-scroll");
    }
  },
  beforeDestroy() {
    this.closeMenu();
  },
  methods: {
    toggleCollapse() {
      this.menuCollapsed = !this.menuCollapsed;
      try {
        localStorage.setItem("d-menu-collapsed", this.menuCollapsed ? "1" : "0");
      } catch (e) {
        // private mode: not remembered
      }
    },
    openMenu() {
      this.menuIsOpened = true;
      document.documentElement.classList.add("is-no-scroll");
    },
    closeMenu() {
      this.menuIsOpened = false;
      document.documentElement.classList.remove("is-no-scroll");
    }
  }
};
</script>
